/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Dashboard_Billing_ResetsInputs */



/**
* | output |
* | --- |
* | "Pool resets {date}" |
*
* @param {Dashboard_Billing_ResetsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_resets = /** @type {((inputs: Dashboard_Billing_ResetsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_ResetsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Pool wird zurückgesetzt am ${i?.date}`)
	return /** @type {LocalizedString} */ (`Pool resets ${i?.date}`)
});